import { Pipe, type PipeTransform } from "@angular/core";

@Pipe({
  name: "jniBooleanToString",
  pure: true,
})
export class BooleanToStringPipe implements PipeTransform {
  transform(value: boolean): unknown {
    return value ? "Yes" : "No";
  }
}
